import React, { useEffect, useState } from "react";
import { Row, Input, Select, Form, Col, Spin, Modal } from "antd";
import { getRequest, putRequest } from "../../api/http";
import userServiceApi from "../../api/userServiceApi";
import { toast } from "react-toastify";
import Preview from "../Preview/preview";
import { EditOutlined, SaveOutlined } from "@ant-design/icons";
import "../table/viewMicrosite.scss";

export default function ViewMicrositeDetails({
  ClearRow,
  orgId,
  HideViewMicrositeHandler,
  showTagsHandler,
  closeModal,
}) {
  const [loading, setLoading] = useState(true);
  const [loader, setLoader] = useState(true);
  const [oneOrgData, setOneOrgData] = useState(null);
  const [microsites, setMicrosites] = useState([]);
  const [microsite, setMicrosite] = useState(null);
  const [isEditingName, setIsEditingName] = useState(false);
  const [isEditingType, setIsEditingType] = useState(false);
  const [editName, setEditName] = useState(null);
  const [editType, setEditType] = useState(null);
  const [partnerData, setPartnerData] = useState({});
  const [OrganisationTypes, setOrganisationTypes] = useState([]);

  const getPartnerDetailsData = () => {
    setLoading(true);
    getRequest(userServiceApi.partnerDetails())
      .then((response) => {
        if (response && response.data) {
          // if (!response.data.mediaLink) {
          //   setIsTabDisable(true);
          // }
          setPartnerData({ ...response.data });
          setOrganisationTypes(response.data.organizationTypes);
          // console.log("atAPI", response.data);
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error.error);
      });
  };

  useEffect(() => {
    getPartnerDetailsData();
  }, []);

  //   const OrganisationTypes = [
  //     {
  //         "id": "BUSINESS_SECTOR",
  //         "name": "Business"
  //     },
  //     {
  //         "id": "COLLEGE_SECTOR",
  //         "name": "College"
  //     },
  //     {
  //         "id": "CHARITY_SECTOR",
  //         "name": "Charity"
  //     },
  //     {
  //         "id": "UNIVERSITY_SECTOR",
  //         "name": "University"
  //     },
  //     {
  //         "id": "PUBLIC_SECTOR",
  //         "name": "Public"
  //     }
  // ];

  const handleEditClickName = () => {
    setIsEditingName(true);
  };

  const handleSaveClickName = async () => {
    try {
      // console.log("edited name before api call", editName)
      await updateOneOrganisationData();
      // console.log("came out of api")
      setIsEditingName(false);
      closeModal();
      // console.log("edit namemeee", isEditingName)
    } catch (error) {
      console.error("Failed to update data.", error);
      toast.error("Please change organisation name before saving.");
    }
  };

  const handleEditClickType = () => {
    setIsEditingType(true);
    // toast("Organisation name also needs to be changes");
  };

  // const nameToId = (name) => {
  //   const foundType = OrganisationTypes.find((type) => type.name === name);
  //   return foundType ? foundType.id : null;
  // };

  const handleSaveClickType = async () => {
    try {
      // console.log("edited type", editType)
      await updateOneOrganisationData();
      setIsEditingType(false);
      closeModal();
    } catch (error) {
      console.error("Failed to update data.", error);
      toast.error("Failed to update data. Please try again.");
    }
  };

  //   console.log("type edited", editedType);
  //   console.log("name edited", editedName);

  const updateOneOrganisationData = async () => {
    if (orgId) {
      try {
        const name = editName;
        // const formatedName = name?.replace(/ /g, "-");
        // console.log("editedname in api call", formatedName)
        const type = editType;
        // console.log("editedtype in api call", type);
        const response = await putRequest(
          userServiceApi.updateOneOrganisationData(orgId, name, type)
        );
        // console.log("response")
        if (response) {
          toast.success("Successfully updated data.");
        } else {
          throw new Error("Failed to update data. No response data.");
        }
      } catch (error) {
        throw error;
      }
    }

  };

  const getOneOrganizationData = async () => {
    if (orgId) {
      try {
        const response = await getRequest(
          userServiceApi.getOneOrganization(orgId)
        );
        // console.log(response, "ressponse");

        if (response.data) {
          setOneOrgData(response.data);
        }
      } catch (error) {
        toast.error(error.error);
      }
    }

  };

  const getMicrositesData = async () => {
    if (orgId) {
      try {
        setLoading(true);
        const response = await getRequest(
          userServiceApi.getMicrositesByOrganization(orgId)
        );

        if (response.data) {
          setMicrosites(response.data);
        }
        setLoading(false);
      } catch (error) {
        toast.error(error.error);
      }
    }

  };

  useEffect(() => {
    getOneOrganizationData();
    getMicrositesData();
    setTimeout(() => {
      setLoader(false);
    }, 1000);
  }, [orgId]);

  const RemoveMicrosite = () => {
    setMicrosite(null);
  };

  const handleCancel = () => {
    closeModal();
  };
  // console.log(oneOrgData);
  if (loading || loader) {
    // return (
    //   <div className="data-loader">
    //     <Spin className="spin" tip="Loading" size="large" />
    //   </div>
    // );
  }
  // else {
  return (
    <>
      <Modal
        open={true}
        onCancel={handleCancel}
        // closeIcon={<img className="closeIcon" src={closeIcon} />}
        footer={null}
        className="viewMicrositeModal"
      >
        {loading || loader ? (
          <div className="approve-container">
            <div className="data-loader">
              <Spin className="spin" tip="Loading" size="large" />
            </div>
          </div>
        ) : (
          <div className="approve-container">

            <div className="partnerInfoStyle">

              {oneOrgData?.mediaLink ? (
                <div className="partnerInfoRow">
                  <div className="partnerInfoCol">
                    <div className="img-container">
                      <img
                        src={oneOrgData?.mediaLink}
                        alt={""}
                        className="preview-image"
                      />
                    </div>
                  </div>
                  <div className="partnerInfoCol">
                    {/* <div className="btn-container">
                     {microsites.map((microsite) => {
                       return (
                         <div className="inputBody-btns">
                           <Button
                             className="view-btn"
                             type="button"
                             onClick={() => ShowSubsectionhandler(microsite.id)}
                           >
                             View Microsite
                           </Button>
                         </div>
                       );
                     })}
                   </div> */}
                  </div>
                </div>
              ) : null}

              <div className="partnerInfoRow">
                <div className="partnerInfoCol">Name</div>
                <div className="partnerInfoCol">{oneOrgData?.name}</div>
              </div>
              <div className="partnerInfoRow">
                <div className="partnerInfoCol">Type</div>
                <div className="partnerInfoCol">{oneOrgData?.type?.length > 0 ? oneOrgData?.type : ""}</div>
              </div>
              <div className="partnerInfoRow">
                <div className="partnerInfoCol">Size</div>
                <div className="partnerInfoCol">
                  {oneOrgData?.size === "MICRO"
                    ? "Micro"
                    : oneOrgData?.size === "SMALL"
                      ? "Small"
                      : oneOrgData?.size === "MEDIUM"
                        ? "Medium"
                        : oneOrgData?.size === "LARGE"
                          ? "Large"
                          : ""}
                </div>
              </div>
              {oneOrgData?.sectorsOutputs?.length > 0 &&
                oneOrgData?.sectorsOutputs[0]?.sectorOutput?.name && (
                  <div className="partnerInfoRow">
                    <div className="partnerInfoCol">Categories</div>
                    <div className="partnerInfoCol">
                      {oneOrgData.sectorsOutputs[0].sectorOutput.name}
                    </div>
                  </div>
                )}

              {oneOrgData?.sectorsOutputs?.length > 0 &&
                oneOrgData?.sectorsOutputs[0]?.subSectorOutput?.name && (
                  <div className="partnerInfoRow">
                    <div className="partnerInfoCol">Sub categories</div>
                    <div className="partnerInfoCol">
                      {oneOrgData.sectorsOutputs[0].subSectorOutput.name}
                    </div>
                  </div>
                )}

              {oneOrgData?.websiteLink ? (
                <div className="partnerInfoRow">
                  <div className="partnerInfoCol">Website</div>
                  <div className="partnerInfoCol"> {oneOrgData?.websiteLink}</div>
                </div>
              ) : null}

              <div className="partnerInfoRow">
                <div className="partnerInfoCol">Email</div>
                <div className="partnerInfoCol"> {oneOrgData?.email}</div>
              </div>
              <div className="partnerInfoRow">
                <div className="partnerInfoCol">Phone</div>
                <div className="partnerInfoCol">{oneOrgData?.phone}</div>
              </div>
              <div className="partnerInfoRow">
                <div className="partnerInfoCol">Address</div>
                <div className="partnerInfoCol">
                  {oneOrgData?.addressOutputs.map((address) => {
                    return address.street;
                  })}</div>
              </div>
                <div className="partnerInfoRow">
                <div className="partnerInfoCol">Postal Code</div>
                <div className="partnerInfoCol">
                  {oneOrgData?.addressOutputs.map((address) => {
                    return address.postalCode;
                  })}</div>
              </div>
            </div>
          </div>
        )}

        {microsite ? (
          <Preview micrositeId={microsite} RemoveMicrosite={RemoveMicrosite} />
        ) : (
          <></>
        )}
      </Modal>
    </>
  );
}

// }
